import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        // 401 here just means "not logged in" – expected on first load.
        // Anything else is a network/server issue worth logging.
        if (e?.response?.status !== 401) {
          console.error("Auth check failed:", formatApiError(e));
        }
        setUser(false);
      }
    })();
  }, []);

  async function login(username, password) {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { username, password });
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatApiError(e));
      return false;
    }
  }

  async function logout() {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // Network/server failure on logout shouldn't block the user;
      // we still clear local state below, but log so it's traceable.
      console.warn("Logout request failed:", formatApiError(e));
    }
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, login, logout, error, setError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
